
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { SelectOption } from "@/service/common/entity/SelectOption";
import { getEnum } from "@/service/supplier-meta/api";
import { enumToOption } from "@/utils";
import { BgInputNumber } from "@banggood/scm-fe";
import { sourceTypeEnum } from "@/service/supplier-meta/enums/sourceTypeEnum";
import BgAreaSelect, {
  BgAreaSelectOption,
} from "@/components/bg-area-select/index.vue";
import { Form } from "element-ui";
import {
  ElementUIFormItemRule,
  ElementUIFormRules,
} from "@/service/supplier-meta/common/supplier-field-ctrl";
import { SupplierForm } from "@/service/supplier-meta/common/SupplierForm";
import { Any } from "@/service/common/entity/Any";
import { FormModel } from "@/service/common/entity/FormModel";
import KuajingbaoCheckInfo from "@/components/kuajingbao-check-info/index.vue";
@Component({
  components: {
    BgInputNumber,
    BgAreaSelect,
    KuajingbaoCheckInfo,
  },
})
export default class SupplierContactInfo extends SupplierForm {
  form = {
    areas: [] as string[],
    linkmanInfo: {
      linkman: "",
      phone: "",
      telPhone: "",
      qq: "",
      email: "",
      province: "",
      city: "",
      area: "",
      address: "",
    },
    netSellInfo: {
      aliWangWang: "",
      shopUrl: "",
    },
  };
  scaleTypeOptions: SelectOption[] = [];
  supplierTypeOptions: SelectOption[] = [];
  paymentTypeOptions: SelectOption[] = [];
  purchaseTypeOptions: SelectOption[] = [];
  servicesOptions: SelectOption[] = [];
  get rules(): ElementUIFormRules {
    return {
      ...this.getFieldsRules([
        "linkmanInfo.linkman",
        "linkmanInfo.phone",
        "linkmanInfo.telPhone",
        "linkmanInfo.qq",
        "linkmanInfo.email",
        "netSellInfo.aliWangWang",
        "netSellInfo.shopUrl",
        "linkmanInfo.province",
        "linkmanInfo.city",
        "linkmanInfo.area",
      ]),
      "linkmanInfo.address": (
        [
          {
            validator: (
              rules: ElementUIFormRules,
              value: Any,
              callback: (msg?: string) => void
            ) => {
              if (!this.form.areas[0]) {
                callback("省份不能为空");
              } else if (!this.form.areas[1]) {
                callback("城市不能为空");
              } else if (
                !this.form.areas[2] &&
                sourceTypeEnum.oa === this.sourceType
              ) {
                callback("地区不能为空");
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ] as ElementUIFormItemRule[]
      ).concat(this.getFieldRules("linkmanInfo.address")),
    };
  }
  created() {
    this.getOptions();
  }
  getFormRef(): Form {
    return this.$refs.form as Form;
  }
  getFormData() {
    return {
      linkmanInfo: {
        ...this.form.linkmanInfo,
        province: this.form.areas[0],
        city: this.form.areas[1],
        area: this.form.areas[2],
      },
      netSellInfo: {
        ...this.form.netSellInfo,
      },
    };
  }
  isAreaSelectOptionDisabled(opt: BgAreaSelectOption, level: number): boolean {
    return level === 1 || level == 2;
    // const sourceType = this.sourceType;
    // if (sourceType === sourceTypeEnum.oa) {
    //   return level === 1 || level == 2;
    // }
    // return level === 1;
  }
  handleAreasChange(val: string[]): void {
    const form = this.$refs.form as Form;
    if (this.form.linkmanInfo.address) {
      form.validateField("linkmanInfo.address");
    }
  }
  getOptions() {
    getEnum("ScaleTypeEnum", true).then((res) => {
      if (res.isSuccess && Array.isArray(res.result)) {
        this.scaleTypeOptions = enumToOption(res.result);
      }
    });
    getEnum("SupplierTypeEnum", true).then((res) =>
      res.isSuccess ? (this.supplierTypeOptions = enumToOption(res.result)) : []
    );
    getEnum("PaymentTypeEnum", true).then((res) => {
      if (res.isSuccess && Array.isArray(res.result)) {
        this.paymentTypeOptions = enumToOption(res.result);
      }
    });
    getEnum("PurchaseTypeEnum", true).then((res) => {
      if (res.isSuccess && Array.isArray(res.result)) {
        this.purchaseTypeOptions = enumToOption(res.result);
      }
    });
  }
  patchFormData(formData: FormModel) {
    super.patchFormData(formData);
    const linkInfo = (formData.linkmanInfo as any) || {};
    const areas = [];
    if (linkInfo.province) {
      areas[0] = linkInfo.province;
    }
    if (linkInfo.city) {
      areas[1] = linkInfo.city;
    }
    if (linkInfo.area) {
      areas[2] = linkInfo.area;
    }
    this.form.areas = areas;
  }
}
